import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Droppable, DragDropContext } from 'react-beautiful-dnd';

import QuestionCard from './QuestionCard';
import { useFormContext } from '../../../../hooks/useForm';

export default function QuestionList({ id: sectionId, departmentId }) {
  const { getSectionQuestions, updateSectionQuestions } = useFormContext();
  const [questions, setQuestions] = useState(null);

  useEffect(() => {
    setQuestions(getSectionQuestions(sectionId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSectionQuestions, sectionId]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const newQuestionsOrder = Array.from(questions);
    const [removed] = newQuestionsOrder.splice(result.source.index, 1);
    newQuestionsOrder.splice(result.destination.index, 0, removed);

    setQuestions(newQuestionsOrder);
    updateSectionQuestions(sectionId, newQuestionsOrder);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="question-cards">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {questions?.map((question, index) => (
              <QuestionCard
                key={question.id}
                question={question}
                sectionId={sectionId}
                index={index}
                departmentId={departmentId}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

QuestionList.propTypes = {
  id: PropTypes.string,
  departmentId: PropTypes.number,
};
